import * as React from 'react';

function FinalScoreBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<text
				transform="translate(0 -2)"
				fill="#6C7680"
				fillRule="evenodd"
				fontFamily="Georgia"
				fontSize={24}
			>
				<tspan x={5} y={22}>
					8
				</tspan>
			</text>
		</svg>
	);
}

export default FinalScoreBlockIcon;
